<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Update Status</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
            style="width:300px"
          >
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Total Influencers: {{payments.length}}</p>
              <!-- <p
                class="pa-0 ma-0 custom-font"
              >Total Amount: ${{totalAmount | thousandSeprator}}</p> -->
              <span v-for="(item, index) in currencyTotals" :key="index">
                <p class="pa-0 ma-0 custom-font" v-if="item">Total <span v-if="index === 'SGD'">Amount in </span> {{index}}: {{utilsFunc.currencySym(index)}} {{item | thousandSeprator}}</p>
              </span>
            </v-card-subtitle>
          </v-card>
        </v-hover>
        <v-form ref="paymentForm" v-model="valid" lazy-validation>
          <v-text-field
            dense
            outlined
            label="PV Number"
            v-model="data.PVNumber"
            v-if="showField('PVNumber')"
            required
            :rules="MessageRules"
          >
          </v-text-field>
          <v-text-field
            dense
            outlined
            label="Bank Reference"
            v-model="data.bank_reference"
            v-if="showField('bankReference')"
            required
            :rules="MessageRules"
          >
          </v-text-field>
          <v-text-field
            v-model="data.payment_date"
            v-on="on"
            dense
            outlined
            label="Payment Date (DD/MM/YYYY)"
            v-if="showField('paymentDate')"
            required
            :rules="MessageRules"
          ></v-text-field>
          <v-text-field
            v-model="data.payment_submission_date"
            v-on="on"
            dense
            outlined
            label="Submission Date (DD/MM/YYYY)"
            v-if="showField('submissionDate')"
            required
            :rules="MessageRules"
          ></v-text-field>
          <v-select
            v-model="data.batch"
            :items="batches"
            label="Select Batch"
            dense
            outlined
            v-if="showField('batch')"
            required
            :rules="MessageRules"
          ></v-select>
          <v-select
            v-model="data.payment_status"
            :items="showStatuses"
            item-value="status"
            item-text="display"
            label="Payment Status"
            dense
            outlined
            v-if="showField('paymentStatus')"
            required
            :rules="MessageRules"
            @change="changeStatus()"
          ></v-select>
          <!-- <v-text-field
            label="Actual Amount"
            v-model.number="data.actualAmount"
            v-if="showField('actualAmount')"
            type="number"
            dense
            outlined
            hide-details
            required
            :rules="MessageRules"
            prefix="S$"
          ></v-text-field> -->
        </v-form>
        <v-simple-table v-if="showField('actualAmount')">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Handle</th>
                <th class="text-left">Amount</th>
                <th class="text-left">Actual Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in payments"
                :key="item.title"
              >
                <td>
                  <div>{{ item.instagram }}</div>
                </td>
                <td>
                  <div>{{ utilsFunc.currencySym(item.currency) }} {{ item.amount }}</div>
                </td>
                <td>
                  <v-text-field
                    label="Amount"
                    type="number"
                    v-model="item.actualAmount"
                    placeholder=""
                    outlined
                    dense
                    hide-details="auto"
                    v-if="item.currency !== 'SGD'"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-dialog>
</template>
<script>
/* eslint-disable */
import campaignAPIs from '../Campaign/campaignAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
// import userAPIs from '../User/userAPIs';
import campaignConfig from '../Campaign/config';
import config from '@/config';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import utils from '@/utils';
export default {
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    payments: Object,
    selectedPaymentStatus: Number
  },
  data () {
    return {
      valid: true,
      isLoading: false,
      data: {
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        batch: '',
        payment_status: 0,
        actualAmount: 0
      },
      paidSearch: '',
      totalAmount: 0,
      paymentStatus: campaignConfig.paymentStatus,
      paymentConsSectionIDs: campaignConfig.paymentConsSectionIDs,
      showStatuses: [],
      batches: ['Batch 1', 'Batch 2'],
      currencyTotals: {},
      MessageRules: [value => !!value || 'Required.'],
      utilsFunc: utils.func
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status,
      paymentUpdateFields: state => state.payment.paymentUpdateFields,
      savedCompletedPayments: state => state.payment.savedCompletedPayments,
      currencyRates: state => state.payment.currencyRates
    }),
    ...mapGetters('payment', [
      'paymentStatusOptions',
      'allowedStatuses'
    ]),
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    }
    // allowedStatuses: function () {
    //   let filtered = this.paymentStatusOptions.filter(option => option.permissions.includes(this.currentUserRole))
    //   return filtered
    // }
  },
  methods: {
    getPaymentStatus(statusVal) {
      let statusText = '-'
      Object.entries(this.paymentStatuses).forEach(item => {
        if (statusVal === item[1].value) {
          statusText = item[1].text
        }
      });
      return statusText
    },
    save() {
      if (!this.$refs.paymentForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          let savePayments = []
          let hasDisabled = false
          this.payments.map(item => {
            if (this.checkDisabled(item)) {
              hasDisabled = true
            } else {
              savePayments.push(item)
            }
          })
          if (hasDisabled) {
            this.$swal({
              html: `Please Enter SwiftCode, Bank Account, Payee Name, Country, Bank Name and Email.`,
              type: 'warning'
            }).then(result => {
              if (result.value) {
                if (savePayments.length) {
                  this.saveEditedPayment(savePayments)
                }
              }
            })
          } else {
            if (savePayments.length) {
              this.saveEditedPayment(savePayments)
            }
          }
        }
      })
    },
    async saveEditedPayment(savePayments) {
      let updateData = savePayments.map(item => {
        let updateObj = {}
        updateObj.id = item.id
        updateObj.handle = item.instagram
        if (item.influencerID) {
          updateObj.influencerID = item.influencerID
        }
        updateObj.campaignID = item.campaignID
        updateObj.type = item.type
        if (item.reportID) {
          updateObj.reportUpdateID = item.reportID
        } else {
          updateObj.reportUpdateID = item.id
        }
        if (item.campaign) {
          updateObj.campaignID = item.campaign.id
        }
        if (item.imported && item.imported !== undefined) {
          updateObj.imported = item.imported
        }
        if (this.data.payment_date !== '') {
          updateObj.payment_date = this.data.payment_date
        }
        if (this.data.payment_submission_date !== '') {
          updateObj.payment_submission_date = this.data.payment_submission_date
        }
        if (this.data.payment_status !== this.paymentStatus.NEW) {
          updateObj.payment_status = this.data.payment_status
        }
        if (this.data.bank_reference !== '') {
          updateObj.bank_reference = this.data.bank_reference
        }
        if (this.data.PVNumber !== '') {
          updateObj.PVNumber = this.data.PVNumber
        }
        if (this.data.batchNo !== '') {
          updateObj.batchNo = this.data.batchNo
        }
        if (item.currency !== '') {
          updateObj.currency = item.currency
        }
        if (item.actualAmount) {
          updateObj.actualAmount = item.actualAmount
        }
        let newPOC = Object.assign({}, {
          id: this.currentUserID,
          timestamp: moment().toISOString()
        })
        let POC = item.POC || []
        let oldPOC = POC.find(p => p.id === this.currentUserID)
        if (!oldPOC) {
          POC.unshift(newPOC)
          updateObj.POC = POC
        }
        return updateObj
      })
      
      // update and save for completed payments
      await this.saveCompletedPayments(savePayments, updateData)
      // Submit request to save edited report data
      this.isLoading = true
      campaignAPIs
      .savePaymentConsolidatedData(updateData)
      .then(async (response) => {
        // Update submitting status
        this.isLoading = false;
        this.close()
        this.$emit('updated', updateData)
        // Show success message
        this.$swal({
          text: 'Payment Updated',
          type: 'success'
        });
      })
      .catch(error => {
        // Update submitting status
        this.isLoading = false;
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    async saveCompletedPayments(selectedPayments, updatePayments) {
      /**
       * This func will check and save for completed payments with update payment data.
       */
      let preProcessingPayments = []
      let importedPayments = []
      let financePayments = []
      let completedPayments = []
      for (let data of updatePayments) {
        if (data.payment_status === this.paymentStatus.PROCESSING  && !data.imported) {
          let spIdx = selectedPayments.findIndex(s => s.id === data.id)
          if (selectedPayments[spIdx]) {
            preProcessingPayments.push(Object.assign({}, selectedPayments[spIdx], data))
          }
        } else {
          if (data.payment_status === this.paymentStatus.PROCESSING && data.imported) {
            let spIdx = selectedPayments.findIndex(s => s.id === data.id)
            if (selectedPayments[spIdx]) {
              importedPayments.push(Object.assign({}, selectedPayments[spIdx], data))
            }
          }
        }
        if (data.payment_status === this.paymentStatus.PARTIAL || data.payment_status === this.paymentStatus.APPROVAL_FINANCE) {
          let spIdx = selectedPayments.findIndex(s => s.id === data.id)
          if (selectedPayments[spIdx]) {
            financePayments.push(Object.assign({}, selectedPayments[spIdx], data))
          }
        }
        if (data.payment_status === this.paymentStatus.PAID) {
          let spIdx = selectedPayments.findIndex(s => s.id === data.id)
          if (selectedPayments[spIdx]) {
            completedPayments.push(Object.assign({}, selectedPayments[spIdx], data))
          }
        }
      }
      if (preProcessingPayments.length) {
        let saveData = await this.buildPaymentsData(preProcessingPayments)
        if (!saveData) return
        await this.$store.dispatch('payment/savePreProcessingPayments', {
          data: saveData
        })
      }
      if (importedPayments.length) {
        let saveData = await this.buildPaymentsData(importedPayments)
        if (!saveData) return
        await this.$store.dispatch('payment/saveImportedPayments', {
          data: saveData
        })
      }
      if (financePayments.length) {
        let saveData = await this.buildPaymentsData(financePayments)
        if (!saveData) return
        await this.$store.dispatch('payment/saveFinancePayments', {
          data: saveData
        })
      }
      if (completedPayments.length) {
        let saveData = await this.buildPaymentsData(completedPayments)
        if (!saveData) return
        await this.$store.dispatch('payment/saveCompletedPayments', {
          data: saveData,
          emailToCreator: true
        })
      }
    },
    async buildPaymentsData(payments) {
      try {
        let data = []
        for (let payment of payments) {
          if (payment.reportID) {
            // if exists or moving between APF or WIP, build to update data
            payment.status = payment.payment_status
            let newObj = {
              reportID: payment.reportID,
              pairingID: payment.pairingID,
              influencer_details: payment.influencer_details,
              transaction_details: payment.transaction_details,
              deliverables: payment.deliverables,
              invoices: payment.invoices,
              campaign: payment.campaign,
              batch: payment.batch || '',
              CC: payment.CC,
              liveDate: payment.liveDate,
              dueDate: payment.dueDate,
              status: payment.status
            }
            if (payment.deliverables) {
              if (typeof payment.deliverables === 'string') {
                newObj.deliverables = {
                  agreed: payment.agreedDeliverables,
                  produced: payment.deliverables
                }
              } else {
                newObj.deliverables = payment.deliverables
              }
            } else {
              newObj.deliverables = {
                agreed: payment.agreedDeliverables || '',
                produced: payment.deliverables || ''
              }
            }
            if (payment.PVNumber) {
              newObj.transaction_details.PVNumber = payment.PVNumber
            }
            if (payment.payment_date) {
              newObj.transaction_details.paymentDate = payment.payment_date
            }
            if (payment.bank_reference) {
              newObj.transaction_details.bankReference = payment.bank_reference
            }
            if (payment.imported) {
              newObj.imported = payment.imported
            }
            if (payment.payment_status === this.paymentStatus.PROCESSING ||
            payment.payment_status === this.paymentStatus.PARTIAL ||
            payment.payment_status === this.paymentStatus.APPROVAL_FINANCE) {
              if (payment.id) {
                newObj.id = payment.id
              }
            }
            data.push(newObj)
            continue
          }
          let newObj = {
            reportID: payment.id,
            pairingID: payment.pairingID,
            influencer_details: {},
            transaction_details: {},
            deliverables: {},
            invoices: {}
          }
          // set influencer details from pairing
          let pairings = await pairingAPIs.getPairedInfluencersByCampaign(payment.campaignID)
          let matchPairing = pairings.find(pairing => pairing.influencer_details && pairing.influencer_details.instagramHandle === payment.handle)
          if (matchPairing) {
            newObj.influencer_details = matchPairing.influencer_details
            // replace handle from pairing to make sure it's correct
            newObj.influencer_details.handle = payment.handle
            delete newObj.influencer_details.instagramHandle
          }
          newObj.influencer_details.bankName = payment.bankName || ''
          newObj.influencer_details.bankAccount = payment.bankAccount || ''
          newObj.influencer_details.swiftCode = payment.swiftCode || ''
          newObj.influencer_details.username = payment.username || ''
          newObj.influencer_details.email = payment.email || ''
          // set transaction details
          newObj.transaction_details = {
            PVNumber: payment.PVNumber || '',
            bankReference: payment.bank_reference,
            submissionDate: payment.payment_submission_date,
            paymentDate: payment.payment_date,
            GSTPercent: payment.GSTPercent || null,
            specialPayment: payment.specialPayment || false,
            currency: payment.currency || 'SGD',
            pairedAmount: parseFloat(payment.pairedAmount),
            amount: parseFloat(payment.amount),
            remainAmount: 0
          }
          if (payment.actualAmount) {
            newObj.transaction_details.actualAmount = payment.actualAmount
          }
          // set campaign details
          newObj.campaign = Object.assign({}, {
            id: payment.campaignID,
            name: payment.campaignName,
            clientName: payment.clientName,
            IONumber: payment.IONumber
          })
          // set deliverables
          // newObj.deliverables = {
          //   agreed: payment.agreedDeliverables,
          //   produced: payment.deliverables
          // }
          if (payment.deliverables) {
            if (typeof payment.deliverables === 'string') {
              newObj.deliverables = {
                agreed: payment.agreedDeliverables,
                produced: payment.deliverables || ''
              }
            } else {
              newObj.deliverables = payment.deliverables
            }
          } else {
            newObj.deliverables = {
              agreed: payment.agreedDeliverables || '',
              produced: payment.deliverables || ''
            }
          }
          // set invoices
          if (payment.invoice) {
            newObj.invoices.internalInvoice = payment.invoice
          }
          if (payment.uploadInvoice) {
            newObj.invoices.uploadInvoice = payment.uploadInvoice
          }
          // set other values
          if (payment.imported) {
            newObj.imported = payment.imported
            // calc remain amt if imported record
            newObj.transaction_details.remainAmount = parseFloat(payment.pairedAmount - payment.amount)
          }
          newObj.batch = payment.batch || ''
          newObj.CC = payment.CC
          newObj.liveDate = payment.liveDate || ''
          newObj.dueDate = payment.dueDate || ''
          newObj.status = payment.payment_status
          data.push(newObj)
        }
        return data
      } catch (error) {
        return false
      }
    },
    checkDisabled(item) {
      if (item.payment_status === this.paymentStatus.PROCESSING) {
        if (!item.swiftCode || !item.bankAccount || !item.username) {
          return true
        }
      }
      return false
    },
    showField(fieldName) {
      // check if update form field has permissions, and status match
      let matchField = this.paymentUpdateFields.find(field => field.name === fieldName)
      if (matchField) {
        return matchField.permissions.includes(this.currentUserRole) && matchField.status.includes(this.data.payment_status)
      }
      return false
    },
    resetForm() {
      this.data = {
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        batch: '',
        payment_status: 0
      }
      this.valid = true
    },
    close() {
      this.$emit('input')
    },
    setDefaultPaymentForSelect(batchNo) {
      if (batchNo === this.paymentConsSectionIDs.IMPORTED ||
      batchNo === this.paymentConsSectionIDs.BATCH_ONE ||
      batchNo === this.paymentConsSectionIDs.BATCH_TWO) {
        this.data.payment_status = this.paymentStatus.APPROVAL_FINANCE
      }
      if (batchNo === this.paymentConsSectionIDs.APPROVAL_FINANCE) {
        this.data.payment_status = this.paymentStatus.PARTIAL
      }
      if (batchNo === this.paymentConsSectionIDs.APPROVAL_LEAD) {
        this.data.payment_status = this.paymentStatus.PARTIAL
      }
      if (batchNo === this.paymentConsSectionIDs.WIP_FINANCE) {
        this.data.payment_status = this.paymentStatus.PAID
      }
    },
    changeStatus() {
      this.selectedPaymentStatus = this.data.payment_status
    },
    detectCurrency(items) {
      // detect different currency values and set to currency object
      let currencies = config.currencies
      currencies.map(c => {
        this.currencyTotals[c] = 0
      })
      items.map(item => {
        if (item.currency !== 'SGD') {
          this.currencyTotals['SGD'] += Number(utils.func.convertCurrency(item.currency, Number(item.amount), this.currencyRates))
        }
        this.currencyTotals[item.currency] += Number(item.amount || 0)
      })
      // Loop through the object and convert values toFixed(2)
      for (const currency in this.currencyTotals) {
        if (this.currencyTotals.hasOwnProperty(currency)) {
          if (this.currencyTotals[currency] > 0) {
            this.currencyTotals[currency] = this.currencyTotals[currency].toFixed(2);
          }
        }
      }
    }
  },
  watch: {
    payments: function(newPayments) {
      this.totalAmount = 0
      this.totalAmount += newPayments.map(payment => payment.amount || 0).reduce((amt1, amt2) => Number(amt1) + Number(amt2), 0)
      this.totalAmount = this.totalAmount.toFixed(2)
      this.detectCurrency(newPayments)
      // filter status based on role and selected status
      if (this.isAdmin) {
        this.showStatuses = Object.assign([], this.allowedStatuses)
      } else this.showStatuses = this.allowedStatuses.filter(al => al.allowedStatusChange.includes(this.selectedPaymentStatus))
      this.resetForm()
      if (newPayments.length) {
        this.setDefaultPaymentForSelect(newPayments[0].batchNo)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// UpdatePaymentInfoModal.vue?30a65463